export default class SiteSearchNarrow {
	constructor(element, options) {
		this.element = element;
		this.options = options;

		// get references to required elements
		this.openButton = this.options.openButton;
		this.field = this.options.field;
		this.overlay = this.options.overlay;
		this.siteHeader = this.options.siteHeader;
		this.invalidClass = "invalid";

		this.boundOnFocus = this.onFocus.bind(this);

		this.init();
		this.watch();
	}

	init() {}

	watch() {
		this.openButton.addEventListener("click", this.toggleSearch.bind(this));
		this.overlay.addEventListener("click", this.closeSiteSearch.bind(this));

		// Validation actually doesn't happen on current live site even though it was in the previous JS.
		// this.element.addEventListener('submit', this.onSearchSubmit.bind(this));
		// this.field.addEventListener('keydown', this.resetValidation.bind(this));
		// this.field.addEventListener('change', this.resetValidation.bind(this));
	}

	openSiteSearch() {
		this.element.removeAttribute("hidden");
		this.overlay.removeAttribute("hidden");
		this.openButton.setAttribute("aria-expanded", "true");
		this.field.focus();

		this.detectFocusLoss();
	}

	closeSiteSearch() {
		this.element.setAttribute("hidden", "");
		this.overlay.setAttribute("hidden", "");
		this.openButton.setAttribute("aria-expanded", "false");

		this.removeFocusLossDetection();
	}

	toggleSearch() {
		if (this.openButton.getAttribute("aria-expanded") === "true") {
			this.closeSiteSearch();
		} else {
			this.openSiteSearch();
		}
	}

	onSearchSubmit(event) {
		var searchQuery = this.field.value;
		if (searchQuery.trim() === "") {
			event.preventDefault();
			this.field.setAttribute("aria-invalid", "true");
			this.field.focus();
		}
	}

	resetValidation() {
		this.field.setAttribute("aria-invalid", "false");
	}

	detectFocusLoss() {
		document.addEventListener("focus", this.boundOnFocus, true);
	}

	removeFocusLossDetection() {
		document.removeEventListener("focus", this.boundOnFocus, true);
	}

	// Bound to this in the constructor as this.boundOnFocus
	onFocus(event) {
		if (!this.siteHeader.contains(event.target)) {
			this.closeSiteSearch();
		}
	}
}



// WEBPACK FOOTER //
// ./project/client/src/core/components/site-header-narrow/site-search-narrow.js